import {styled} from "@core-ui/react-stitch";

const CardMedia = styled.div(() => ({
  marginBottom: "0.5rem",
}));

export default CardMedia;
